module.exports = __webpack_public_path__ + "img/phone-icon.659b33f3.svg";